export default "__VITE_ASSET__DaXbypy4__"